// extracted by mini-css-extract-plugin
export default {"spinner-container":"Nc1b5I","spinnerContainer":"Nc1b5I","spinner":"yycevx"};